export default {"src":"/_next/static/image/public/images/flags/flag_261.bf8ac47103db622bbf0a880c143f1d67.svg","height":16,"width":24};